import {CLIENT, HAO_DOMAIN, removeLocal} from "helpers/utils.js";

export function fetchExpenses(page = 1, limit = 10, infoFn, setRowCount) {
  const offset = (page - 1) * limit;
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/finance/expenses?offset=${offset}&limit=${limit}`;

  return fetch(url, {method: 'GET', credentials: 'include'}).then(res => {
    if (res.status === 200) {
      return res.json();
    } else if (res.status === 401) {
      removeLocal('user');
    }
    throw new Error(`Failed to fetch expenses: ${res.status}`);
  }).then(data => {
    if (infoFn) infoFn(data?.expenses || []);
    // Updated to use pagination object instead of total
    if (setRowCount) setRowCount(data?.pagination?.total || 0);
    return data;
  }).catch(err => {
    console.error('Error fetching expenses:', err);
    if (infoFn) infoFn([]);
    if (setRowCount) setRowCount(0);
    removeLocal('user');
    throw err;
  });
}

export function createExpense(expenseData) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/finance/expenses`;

  return fetch(url, {method: 'POST', credentials: 'include',
    body: JSON.stringify(expenseData)
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to create expense: ${res.status}`);
  }).then(data => {
    console.log('Expense created successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error creating expense:', err);
    throw err; // Re-throw to be handled by the calling component
  });
}

export function updateExpense(expenseId, expenseData) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/finance/expenses/${expenseId}`;

  return fetch(url, {method: 'PUT', credentials: 'include',
    body: JSON.stringify(expenseData)
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to update expense: ${res.status}`);
  }).then(data => {
    console.log('Expense updated successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error updating expense:', err);
    throw err;
  });
}

export function deleteExpense(expenseId) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/finance/expenses/${expenseId}`;

  return fetch(url, {
    method: 'DELETE',
    credentials: 'include'
  }).then(res => {
    if (res.status === 200) {
      return true;
    }
    throw new Error(`Failed to delete expense: ${res.status}`);
  }).then(() => {
    console.log('Expense deleted successfully');
    return true;
  }).catch(err => {
    console.error('Error deleting expense:', err);
    throw err;
  });
}

export function linkDocumentToExpense(expenseId, documentId) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/link/expenses/${expenseId}/document`;

  return fetch(url, {
    method: 'PUT',
    credentials: 'include',
    body: JSON.stringify({document_id: documentId})
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to link document to expense: ${res.status}`);
  }).then(data => {
    console.log('Document linked to expense successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error linking document to expense:', err);
    throw err;
  });
}

export function unlinkDocumentFromExpense(expenseId) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/link/expenses/${expenseId}/document`;

  return fetch(url, {
    method: 'DELETE',
    credentials: 'include'
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to unlink document from expense: ${res.status}`);
  }).then(data => {
    console.log('Document unlinked from expense successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error unlinking document from expense:', err);
    throw err;
  });
}

export function fetchBalanceSummary(setBalanceFn) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/finance/balance`;

  return fetch(url, {
    method: 'GET',
    credentials: 'include'
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    } else if (res.status === 401) {
      removeLocal('user');
    }
    throw new Error(`Failed to fetch balance summary: ${res.status}`);
  }).then(data => {
    if (setBalanceFn) setBalanceFn(data);
    return data;
  }).catch(err => {
    console.error('Error fetching balance summary:', err);
    throw err;
  });
}
